import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, FilterButton, Popover, TextInput } from '@pocketlaw/tetris';
import { getNumberDisplayValue } from './utils';
import { useFilter } from '../useFilter';
export function NumberRangeOperator(props) {
    var _a, _b, _c, _d;
    const { name } = props;
    const filter = useFilter(name);
    const fromValue = ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.gte) || ((_b = filter.value) === null || _b === void 0 ? void 0 : _b.gt);
    const toValue = ((_c = filter.value) === null || _c === void 0 ? void 0 : _c.lte) || ((_d = filter.value) === null || _d === void 0 ? void 0 : _d.lt);
    const initiallyOpen = !(fromValue || toValue);
    const [open, setOpen] = useState(initiallyOpen);
    const displayValue = getNumberDisplayValue(fromValue, toValue);
    const handleSetField = (key) => (ev) => {
        const { value } = ev.target;
        const numberValue = parseInt(value, 10);
        filter.setValue(Object.assign(Object.assign({}, (filter.value || {})), { [key]: numberValue }));
    };
    return (<Popover shadow="300" open={open} padding={0} onClose={() => setOpen(false)} target={<FilterButton type="button" appearance={filter.isTouched ? 'draft' : 'default'} onClick={() => setOpen(!open)}>
          {displayValue}
        </FilterButton>}>
      <Box gap="md" px="md" pb="md">
        <TextInput label={t({ message: 'Greater than or equal to', comment: 'Insights: Number range filter: From' })} placeholder={t({ message: 'From', comment: 'Insights: Number range filter: From' })} type="number" value={fromValue || ''} onChange={handleSetField('gte')}/>
        <TextInput label={t({ message: 'Less than or equal to', comment: 'Insights: Number range filter: To' })} placeholder={t({ message: 'To', comment: 'Insights: Number range filter: To' })} type="number" value={toValue || ''} onChange={handleSetField('lte')}/>
      </Box>
    </Popover>);
}
